import { Either } from 'purify-ts';
import { StorageFailure } from './storage-failure';
import { Key, ObjectType } from './types';

export abstract class IStorageRepository {
  public abstract getStorage<T extends Key>(key: T): Either<StorageFailure, ObjectType<T>>;

  public abstract setStorage<T extends Key>(key: T, data: ObjectType<T>): void;

  public abstract deleteFromStorage(key: Key): void;

  public abstract clearAll(): void;
}
